import DownloadIcon from "@mui/icons-material/Download";
import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { DownloadActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { EXPORT_FILE_NAME } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

const UserGuide = () => {
  const dispatch = useAppDispatch();
  const downloading = useAppSelector(
    (state) => state.AppConfigReducer.downloading
  );

  const onDownloadUserGuideVN = async () => {
    dispatch(
      DownloadActions.downloadVNUserGuide.request({
        fileName: EXPORT_FILE_NAME.vnUserGuide,
        isPdf: true,
      })
    );
  };
  const onDownloadUserGuideEN = async () => {
    dispatch(
      DownloadActions.downloadENUserGuide.request({
        fileName: EXPORT_FILE_NAME.enUserGuide,
        isPdf: true,
      })
    );
  };
  return (
    <Box>
      <Typography variant="h2" sx={{ paddingBottom: "20px" }}>
        {I18nTranslator(translations.settings.userguide)}
      </Typography>
      <Box sx={{ paddingTop: "10px" }}>
        <Stack direction={"row"} spacing={2} pt={"6px"}>
          <LoadingButton
            loading={downloading}
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={onDownloadUserGuideEN}
          >
            {I18nTranslator(translations.settings.elancoUserGuideDownload)}
          </LoadingButton>
          <LoadingButton
            loading={downloading}
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={onDownloadUserGuideVN}
          >
            {I18nTranslator(translations.settings.schenkerUserGuideDownload)}
          </LoadingButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default UserGuide;
